import { getSnowplowEventPayload, logAnalyticsEvent } from 'Services/analytics/analytics';
import { ANALYTICS_CATEGORIES, SNOWPLOW_EVENTS } from 'Services/analytics/analytics.const';

const { AI_COMPANION } = ANALYTICS_CATEGORIES;
const { CLICK } = SNOWPLOW_EVENTS;

export const triggerAiCompanionNewChatClickedEvent = (): void => {
	const eventPayload = getSnowplowEventPayload({
		category: AI_COMPANION,
		name: 'dlr_ai_companion_new_chat_clicked',
		schemaName: CLICK.SCHEMA,
		version: CLICK.VERSION,
	});

	logAnalyticsEvent({ eventPayload });
};
